/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Copilot_Placeholder3Inputs */

const zh_landing_copilot_placeholder3 = /** @type {(inputs: Landing_Copilot_Placeholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为 HSK4 核心词汇创建闪卡`)
};

const en_landing_copilot_placeholder3 = /** @type {(inputs: Landing_Copilot_Placeholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create flashcards for HSK4 essential vocabulary`)
};

const es_landing_copilot_placeholder3 = /** @type {(inputs: Landing_Copilot_Placeholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea tarjetas de memoria para el vocabulario esencial del HSK4`)
};

/**
* | output |
* | --- |
* | "Create flashcards for HSK4 essential vocabulary" |
*
* @param {Landing_Copilot_Placeholder3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_copilot_placeholder3 = /** @type {((inputs?: Landing_Copilot_Placeholder3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Copilot_Placeholder3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_copilot_placeholder3(inputs)
	if (locale === "en") return en_landing_copilot_placeholder3(inputs)
	return es_landing_copilot_placeholder3(inputs)
});